import React, { useEffect, useRef } from 'react';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

import { getOrganizationIdentification } from '../../../utils/windowStorage';
import config from '../../../config';

const boxStyles = {
  height: 'calc(100vh - 166px)',
  minHeight: '300px',
  iframe: {
    height: '100%'
  }
};

export const VpPluginPreview = ({ pluginId, hasUpdatedPlugin, hasPublishedPlugin }) => {
  const scriptDidMount = useRef(false);
  const organizationId = getOrganizationIdentification();

  useEffect(() => {
    if (scriptDidMount.current === true) {
      return;
    }

    if (pluginId) {
      const script = document.createElement('script');
      script.src = `${config.pluginURL}/v2/current/injectWidget.js`;
      script.type = 'text/javascript';

      document.body.appendChild(script);

      scriptDidMount.current = true;

      return () => {
        document.body.removeChild(script);
      };
    }
  }, [pluginId]);

  const iframeSrcDidMount = useRef(false);

  const refreshPreview = (hasUpdated) => {
    if (pluginId && hasUpdated) {
      const iframe = document.getElementById(`vpFrame-${pluginId}`);

      if (iframe) {
        // now that we have updated plugin settings we need to re-render the iframe so we can see the changes
        // eslint-disable-next-line no-self-assign
        iframe.src = iframe.src;
      }
    }
  };

  useEffect(() => {
    // run once
    if (iframeSrcDidMount.current === false) {
      iframeSrcDidMount.current = true;
      return;
    }
  }, []);
  useEffect(() => {
    refreshPreview(hasUpdatedPlugin);
  }, [pluginId, hasUpdatedPlugin]);
  useEffect(() => {
    refreshPreview(hasPublishedPlugin);
  }, [pluginId, hasPublishedPlugin]);

  return (
    <Box
      sx={boxStyles}
      className="videopeel-widget-container"
      data-plugin-id={pluginId}
      data-vp-organization-id={organizationId}
      data-preview="true"
    ></Box>
  );
};

VpPluginPreview.propTypes = {
  pluginId: PropTypes.string,
  hasUpdatedPlugin: PropTypes.bool,
  hasPublishedPlugin: PropTypes.bool
};

export default VpPluginPreview;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpPluginPreview/VpPluginPreview.jsx